module.exports = __webpack_public_path__ + "fe6ae790d0a4b9e8fc66b96893ac3bf0.svg";